// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mps5eqsXYIgyydwgPMNX{align-items:center;gap:10px;width:100%;margin-bottom:4px;padding:8px 6px;display:flex}.k8W6AEg5yQyKv7togfIX{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:24px}.k8W6AEg5yQyKv7togfIX::placeholder{color:var(--content-primary-disabled)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textField": `mps5eqsXYIgyydwgPMNX`,
	"search": `k8W6AEg5yQyKv7togfIX`
};
export default ___CSS_LOADER_EXPORT___;
